var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("v-list-item", [
    _c("div", { staticClass: "entity-metadata-row-container" }, [
      _c("div", [
        _c("strong", [_vm._v(_vm._s(_vm.entityMetadata.displayName) + ":")]),
      ]),
      _vm.entityMetadata.metadataType == _vm.metadataType.Enum
        ? _c(
            "div",
            [
              _c("v-select", {
                attrs: {
                  dense: "",
                  filled: "",
                  label: "valore",
                  clearable: "",
                  "hide-details": "",
                  items: _vm.entityMetadata.options,
                },
                model: {
                  value: _vm.entityMetadata.value,
                  callback: function ($$v) {
                    _vm.$set(_vm.entityMetadata, "value", $$v)
                  },
                  expression: "entityMetadata.value",
                },
              }),
            ],
            1
          )
        : _vm.entityMetadata.metadataType == _vm.metadataType.Datetime
        ? _c(
            "div",
            [
              _c("DatePicker", {
                attrs: {
                  textBoxLabel: "data",
                  hide_details: true,
                  clearable: true,
                },
                model: {
                  value: _vm.entityMetadata.value,
                  callback: function ($$v) {
                    _vm.$set(_vm.entityMetadata, "value", $$v)
                  },
                  expression: "entityMetadata.value",
                },
              }),
            ],
            1
          )
        : _vm.entityMetadata.metadataType == _vm.metadataType.String
        ? _c(
            "div",
            [
              _c("v-text-field", {
                attrs: {
                  filled: "",
                  clearable: "",
                  dense: "",
                  "hide-details": "",
                  label: "valore",
                },
                model: {
                  value: _vm.entityMetadata.value,
                  callback: function ($$v) {
                    _vm.$set(_vm.entityMetadata, "value", $$v)
                  },
                  expression: "entityMetadata.value",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }